"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
const libs_parsing_1 = require("libs.parsing");
/** Parse a text template into a token tree */
class Parser {
    parse(template) {
        return this.parseTemplate(new libs_parsing_1.StringReader(template), {});
    }
    parseTemplate(reader, endChars) {
        const result = [];
        while (true) {
            if (reader.reachedEnd())
                break;
            const char = reader.getChar();
            if (endChars[char])
                break;
            result.push(char === '{' ? this.parsePattern(reader) : this.parseString(reader, Object.assign(Object.assign({}, endChars), { '{': true })));
        }
        return result;
    }
    parseString(reader, endChars) {
        const result = [];
        while (true) {
            if (reader.reachedEnd())
                break;
            let char = reader.getChar();
            if (endChars[char])
                break;
            if (char === '\\') {
                // The next character is escaped
                reader.advance();
                char = reader.getChar();
                if (char === 'n')
                    char = '\n';
                if (char === '!') {
                    // sub-string escaped with \![end_char]...[end_char]
                    reader.advance();
                    const endChar = reader.getChar();
                    reader.advance();
                    char = this.parseString(reader, { [endChar]: true });
                }
                if (char === undefined)
                    throw new libs_parsing_1.ParserError(reader, 'Unexpected end of string after an escape character');
            }
            result.push(char);
            reader.advance();
        }
        return result.join('');
    }
    parsePattern(reader) {
        const startChar = reader.getChar();
        if (startChar !== '{')
            throw new libs_parsing_1.ParserError(reader, '{ expected');
        reader.advance();
        const name = this.parseName(reader, { '}': true, '|': true });
        const formatters = this.parseFormatters(reader);
        const endChar = reader.getChar();
        if (endChar !== '}')
            throw new libs_parsing_1.ParserError(reader, '{ expected');
        reader.advance();
        return { name, formatters };
    }
    parseFormatters(reader) {
        const result = [];
        while (true) {
            const char = reader.getChar();
            if (char !== '|')
                break;
            reader.advance();
            result.push(this.parseFormatter(reader));
        }
        return result;
    }
    parseFormatter(reader) {
        const endChars = { ':': true, '}': true, '|': true };
        const name = this.parseName(reader, endChars);
        let char = reader.getChar();
        const subTemplates = [];
        while (char === ':') {
            reader.advance();
            subTemplates.push(this.parseTemplate(reader, endChars));
            char = reader.getChar();
        }
        return { name, subTemplates };
    }
    parseName(reader, endChars) {
        const result = [];
        while (true) {
            if (reader.reachedEnd())
                break;
            const char = reader.getChar();
            if (endChars[char])
                break;
            result.push(char);
            reader.advance();
        }
        if (result.length === 0)
            throw new libs_parsing_1.ParserError(reader, 'name should have at least one character');
        return result.join('');
    }
}
exports.Parser = Parser;
//# sourceMappingURL=parser.js.map